export const PIXELS_TYPES = {
  CLICK: 'click',
  DISPLAY: 'display',
  TRACKING: 'tracking',
};
